import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import store from '@/store';
import { memberApi } from "@/utils/memberApi.js"
import { Message } from 'element-ui';

// import {memberApi} from '@/utils/memberApi'  

Vue.use(VueRouter)

const routes = [
  // 你的路由配置保持不变
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '伍號酒店' }
  },
  {
    path: '/about',
    name: 'about',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/room',
    name: 'room',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/HotelRoomView.vue')
  },
  {
    path: '/artspace',
    name: 'artspace',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ArtSpaceView.vue')
  },
  {
    path: '/entertainment',
    name: 'entertainment',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/EntertainmentView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/ContactView.vue')
  },
  {
    path: '/booking',
    name: 'booking',
    meta: { title: '伍號酒店' },
    component: () => import(/* webpackChunkName: "about" */ '../views/BookingView.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: { title: '伍號酒店', requiresAuth: false }, // 不需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/user/LoginView.vue')
  },
  {
    path: '/user/orders',
    name: 'order',
    meta: { title: '伍號酒店', requiresAuth: false }, // 需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/OrderView.vue')
  },
  {
    path: '/user/profile',
    name: 'profile',
    meta: { title: '伍號酒店', requiresAuth: true }, // 需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/PerCenterView.vue')
  },
  {
    path: '/register',
    name: 'register',
    meta: { title: '伍號酒店', requiresAuth: false }, // 不需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/RegisterView.vue')
  },
  {
    path: '/private',
    name: 'private',
    meta: { title: '伍號酒店', requiresAuth: false }, // 需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/user/PrivateView.vue')
  },
  {
    path: '/uagreement',
    name: 'uagreement',
    meta: { title: '伍號酒店', requiresAuth: false }, // 不需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/user/UAgreementView.vue')
  },
  {
    path: '/update',
    name: 'update',
    meta: { title: '伍號酒店', requiresAuth: false }, // 需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/user/UpdateInfoView.vue')
  },
  {
    path: '/media',
    name: 'media',
    meta: { title: '伍號酒店', requiresAuth: false }, // 需要登录
    component: () => import(/* webpackChunkName: "about" */ '../views/MediaSpaceView.vue')
  },
  {
    path: '/webSite',
    name: 'media',
    meta: { title: '伍號酒店', requiresAuth: false },
    component: () => import('../views/webViews/webView.vue')
  }, 
  {
    path: '/guide',
    name: 'guide',
    meta: { title: '伍號酒店', requiresAuth: false },
    component: () => import('../views/guideViews/guideIndex.vue')
  }, 
  {
    path: '/gtrans',
    name: 'gtrans',
    meta: { title: '伍號酒店', requiresAuth: false },
    component: () => import('../views/guideViews/guideTransView.vue')
  }, 
  {
    path: '/gtransde',
    name: 'gtransde',
    meta: { title: '伍號酒店', requiresAuth: false },
    component: () => import('../views/guideViews/guideTransDetail.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 全局前置守卫 - 修复版
router.beforeEach(async (to, from, next) => {
  store.commit('changeLoad', true)

  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }

  // 只有访问需要登录的页面时，才调用用户信息接口
  if (to.meta.requiresAuth) {
    try {
      // 等待接口返回结果（关键：用await等待异步完成）
      const res = await memberApi.getMemberInfo();
      console.log('info===>', res);

      if (res.errCode === '000') {
        next(); // 正常跳转
      } else {
        // 未登录/登录失效，跳转到登录页
        Message.warning('登录超时，请重新登录！');
        next({ path: '/login', query: { redirect: to.fullPath } }); // 记录来源页面，登录后可跳转回来
      }
    } catch (error) {
      // 接口请求失败（网络错误、token过期等）
      console.error('获取用户信息失败：', error);
      next({ path: '/login' }); // 跳转到登录页
    }
  } else {
    // 不需要登录的页面，直接跳转
    next();
  }
});

// 全局后置守卫
router.afterEach(() => {
  // 隐藏加载动画（延迟300ms确保动画效果）
  setTimeout(() => {
    store.commit('changeLoad', false)
  }, 1000);
});

export default router